<esn-page-header [title]="greeting()" subtitle="Your EchoSpaces portal — pick up where you left off" />

<section class="welcome" aria-labelledby="welcome-title">
  <esn-accent-hexagon />
  <div class="welcome__copy">
    <h2 class="welcome__title" id="welcome-title">Everything your islands need, in one place</h2>
    <p class="welcome__text">
      Build an island, fill its spaces with content and link each piece to the placeholder where it belongs.
      Published islands are live for everyone you invite.
    </p>
  </div>
</section>

<nav aria-label="Quick links">
  <ul class="links">
    @for (link of links(); track link.id) {
      <li>
        <a class="link" [routerLink]="link.route">
          <span class="link__icon"><esn-icon [name]="link.icon" [size]="24" /></span>
          <span class="link__copy">
            <span class="link__title">{{ link.title }}</span>
            <span class="link__text">{{ link.text }}</span>
          </span>
          <esn-icon class="link__chevron" name="chevron-right" [size]="20" />
        </a>
      </li>
    }
  </ul>
</nav>
